import { DEFAULT_BASEMAP_STYLE, VIF_CONSTANTS } from '../constants';
import { type MapVif } from 'common/visualizations/vif';

export const defaultMapVif: MapVif = {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION,
  },
  configuration: {
    datasetMetadata: false,
    locateUser: false,
    panAndZoom: true,
    viewSourceDataLink: true,
    basemapOptions: {
      basemapStyle: DEFAULT_BASEMAP_STYLE,
      geoCoderControl: true,
      geoLocateControl: true,
      navigationControl: true,
    },
  },
  description: '',
  series: [
    {
      color: {
        primary: '#eb6900',
      },
      dataSource: {
        datasetUid: null,
        dimension: {
          columnName: null,
          aggregationFunction: null,
        },
        measure: {
          columnName: null,
          aggregationFunction: 'count',
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'map',
      visible: true,
      primary: true,
    },
  ],
  title: '',
};
